module.exports = __webpack_public_path__ + "img/0Q3B8360-70_H_BlackMatted.db32f6d4.jpg";